import './ReCAPTCHAPolicy.scss';

const ReCAPTCHAPolicy = () => (
  <section className="recaptcha-policy">
    <p className="recaptcha-policy__text">
      Esse site é protegido pelo reCAPTCHA e a{' '}
      <a
        className="recaptcha-policy__link"
        href="https://policies.google.com/privacy"
      >
        política de privacidade
      </a>{' '}
      e os{' '}
      <a
        className="recaptcha-policy__link"
        href="https://policies.google.com/terms"
      >
        termos de serviço
      </a>{' '}
      do Google se aplicam.
    </p>
  </section>
);

export default ReCAPTCHAPolicy;
